/* eslint-disable max-len */
import update from 'immutability-helper';
import moment from 'moment-timezone';
import generateUniqueId from '../../../shared/utils/generateUniqueId';
import {
  FETCH_CAL_WORKOUT_CALENDAR_FULFILLED,
  FETCH_CAL_WORKOUT_CALENDAR_REJECTED,
  FETCH_CAL_WORKOUT_CALENDAR_START,
  SET_ACTIVE_MODAL,
  SET_ACTIVE_SECOND_LAYER_MODAL,
  SET_SWAP_DROPDOWN_TOGGLE_ENABLED,
  SET_IS_PRIMARY_ANIMATED_SIDE_BAR_OPEN,
  SET_IS_CALENDAR_OPTIONS_DROPDOWN_MENU_OPEN,
  SET_IS_STATIC_ADD_COLUMN_DROPDOWN_MENU_OPEN,
  SET_IS_SUPERSET_PICKER_OPEN,
  SET_SUPERSET_PICKER_OPEN_BY_ID,
  REMOVE_SUPERSET_PICKER_OPEN_BY_ID,
  SET_PRIMARY_SIDE_BAR_DATA_TAG,
  SET_SECONDARY_SIDE_BAR_DATA_TAG,
  SET_SELECTED_REDUX_CALENDAR,
  SET_SELECTED_REDUX_NON_DATE_BASED_PROGRAM,
  SET_SELECTED_SAVED_WORKOUT,
  SET_IS_CLONE_DRAGGING,
  SET_HEADER_HEIGHT,
  FETCH_ALL_EXERCISES_START,
  FETCH_ALL_EXERCISES_FULFILLED,
  FETCH_ALL_EXERCISES_REJECTED,
  SET_SELECTED_DATE,
  SET_SELECTED_PROGRAM_DAY_NUMBER,
  SET_SELECTED_MONTH,
  SET_FIRST_MONTH_IN_PICKER,
  SET_SIDE_BAR_EXERCISES_SEARCH_TERM,
  FETCH_CALENDAR_ITEMS_START,
  FETCH_CALENDAR_ITEMS_FULFILLED,
  FETCH_CALENDAR_ITEMS_REJECTED,
  FETCH_RECURRING_CALENDAR_ITEMS_FULFILLED,
  SET_COMBINE_WITH_ID,
  SET_SUPERSET_PICKER,
  SET_CALENDAR_PANEL_CONTAINER_WIDTH,
  SET_ANIMATED_SIDEBAR_CONTAINER_WIDTH,
  SET_SELECTED_ITEMS,
  SET_SELECTED_ITEM,
  REMOVE_SELECTED_ITEM,
  SET_COPIED_SELECTED_ITEMS,
  SET_EXPANDED_ITEMS,
  SET_EXPANDED_ITEM,
  REMOVE_EXPANDED_ITEM,
  SET_WEEK_VIEW_EXPANDED_DAY,
  SET_ACTIVE_EXERCISE_ID,
  FOCUS_NEXT_PRESAVE_ITEM,
  FOCUS_NEXT_PRESAVE_PROGRAM_ITEM,
  SAVE_CALENDAR_EXERCISE_FULFILLED,
  SAVE_CALENDAR_EXERCISE_REJECTED,
  SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_FULFILLED,
  // SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_REJECTED,
  SET_CALENDAR_CONTAINER_SCROLL_POSITION,
  SET_ADD_INFO_CONTENT,
  SET_IFRAMELY_ERROR,
  UPLOAD_CALENDAR_MEDIA_FULFILLED,
  UPLOAD_CALENDAR_MEDIA_REJECTED,
  // UPLOAD_MEDIA_BY_URL_START,
  // UPLOAD_MEDIA_BY_URL_FULFILLED,
  // EDIT_THUMBNAIL_START,
  EDIT_THUMBNAIL_FULFUILLED,
  // EDIT_THUMBNAIL_REJECTED,
  CREATE_EXERCISE_FULFILLED,
  FETCH_DOCUMENTS_FULFILLED,
  FETCH_DOCUMENT_FULFILLED,
  FETCH_FOLDER_FULFILLED,
  ADD_ASSET,
  FETCH_PARENT_CALENDARS_FULFILLED,
  FETCH_PARENT_CALENDARS_REJECTED,
  FETCH_CALENDAR_SELECT_ATHLETES_START,
  FETCH_CALENDAR_SELECT_ATHLETES_FULFILLED,
  FETCH_CALENDAR_SELECT_ATHLETES_REJECTED,
  SET_CLICKED_UPGRADE_NOW,
  SET_NEW_PRESAVE_ITEM_FROM_CREATE_EXERCISE_FORM,
  UPDATE_PROGRAMMED_CALENDAR_ITEM_FULFILLED,
  UPDATE_PROGRAMMED_CALENDAR_ITEM_REJECTED,
  UPDATE_SAVED_WORKOUT_ITEM_FULFILLED,
  SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_FULFILLED,
  REVERT_SWAPPED_ITEM_FULFILLED,
  CREATE_TAG_FOR_ACCOUNT_FULTILLED,
  FETCH_ACCOUNT_TAGS_FULFILLED,
  ADD_PRESAVED_ITEM_TO_CALENDAR_ITEMS_ARRAY,
  ADD_PRESAVED_ITEM_TO_PROGRAM_ITEMS_ARRAY,
  UPDATE_PRESAVED_CALENDAR_ITEM,
  UPDATE_PRESAVED_PROGRAM_ITEM,
  SET_ON_BEFORE_CAPTURE,
  SET_CALENDAR_CONTENT_SCROLL_CONTAINER_TOP_POSITION,
  REMOVE_PRESAVE_ITEM_FROM_REDUX,
  REMOVE_PRESAVE_PROGRAM_ITEM_FROM_REDUX,
  LOG_REDUX_PRESAVE_ADD_INFO,
  LOG_REDUX_PRESAVE_DESCRIPTION,
  FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_FULFILLED,
  CREATE_QUESTION_FOR_ACCOUNT_FULTILLED,
  CLEAR_NEWLY_CREATED_QUESTION,
  SET_QUESTION_COUNT,
  SET_DELETE_STACK,
  SET_SELECTED_REDUX_ATHLETE,
  SET_CALENDAR_ITEMS,
  SET_NON_DATE_BASED_PROGRAM_ITEMS,
  SET_NON_DATE_BASED_PROGRAM_DAYS,
  SET_RECURRING_CALENDAR_ITEMS,
  CLEAR_BEFORE_RECURRING_CALENDAR_ITEMS,
  CLEAR_AFTER_RECURRING_CALENDAR_ITEMS,
  CLEAR_CALENDAR_ITEMS,
  CLEAR_NON_DATE_BASED_PROGRAM_ITEMS,
  DELETE_SAVED_CALENDAR_ITEM_FULFILLED,
  DELETE_SAVED_WORKOUT_ITEM_FULFILLED,
  UNDO_DELETE_SAVED_WORKOUT_ITEM_FULFILLED,
  UNDO_DELETE_SAVED_CALENDAR_ITEM_FULFILLED,
  CONVERT_RECURRING_ITEM_FULFILLED,
  DELETE_RECURRING_ITEM_FULFILLED,
  UPDATE_RECURRING_ITEM_SCHEDULE_FULFILLED,
  SET_IS_DRAGGING,
  SET_DRAG_SOURCE,
  SET_DRAGGED_ITEM,
  SET_REDUX_CALENDAR_CONTAINERS,
  SET_PROGRAMMED_CALENDAR_ITEMS,
  MOVE_EXERCISE_BETWEEN_DATES_START,
  MOVE_EXERCISE_BETWEEN_DATES_FULFILLED,
  MOVE_EXERCISE_BETWEEN_DATES_REJECTED,
  MULTI_MOVE_EXERCISE_BETWEEN_DATES_FULFILLED,
  MOVE_NON_DATE_BASED_EXERCISE_BETWEEN_DAYS_FULFILLED,
  FETCH_SAVED_WORKOUTS_FULFILLED,
  FETCH_SAVED_WORKOUT_DETAIL_START,
  FETCH_SAVED_WORKOUT_DETAIL_FULFILLED,
  FETCH_SAVED_WORKOUT_DETAIL_REJECTED,
  FETCH_SAVED_WORKOUT_FULFILLED,
  SET_COMBINE_WITH_INFO,
  SET_LAST_UPDATE_TIME,
  UPDATE_WORKOUT_INFO_NAME_FULFILLED,
  UPDATE_WORKOUT_INFO_COLOR_FULFILLED,
  UPDATE_NON_DATE_BASED_WORKOUT_INFO_NAME_FULFILLED,
  SAVE_WORKOUT_TEMPLATE_FULFILLED,
  SHARE_WORKOUT_INFO_START,
  SHARE_WORKOUT_INFO_FULFILLED,
  SHARE_WORKOUT_INFO_REJECTED,
  REVERT_LAST_KNOWN_CORRECT_ORDER,
  REVERT_LAST_KNOWN_CORRECT_ORDER_FOR_SAVED_WORKOUT,
  FETCH_CALENDAR_PICKER_ITEMS_START,
  FETCH_CALENDAR_PICKER_ITEMS_FULFILLED,
  FETCH_CALENDAR_PICKER_ITEMS_REJECTED,
  FETCH_AND_SET_DEFAULT_CALENDAR_FULFILLED,
  FETCH_AND_SET_URL_ATHLETE_FULFILLED,
  FETCH_EXERCISE_FULFILLED,
  FETCH_EXERCISE_REJECTED,
  SET_EXERCISE_PICKER_SEARCH_TERM,
  CREATE_PARENT_CALENDAR_START,
  CREATE_PARENT_CALENDAR_FULFILLED,
  CREATE_PARENT_CALENDAR_REJECTED,
  CREATE_A_SAVED_WORKOUT_START,
  CREATE_A_SAVED_WORKOUT_FULFILLED,
  CREATE_A_SAVED_WORKOUT_REJECTED,
  CREATE_PARENT_CHILD_CALENDAR_FULFILLED,
  CREATE_PARENT_CHILD_CALENDAR_REJECTED,
  CLEAR_MOST_RECENTLY_ADDED_CALENDAR_ITEM_TRACKER,
  SET_IS_BEFORE_RECURRING_SECTION_EXPANDED,
  SET_IS_AFTER_RECURRING_SECTION_EXPANDED,
  SET_IS_ATHLETE_ADDED_ITEMS_SECTION_EXPANDED,
  SET_PLACEHOLDER_INFO,
  SET_DRAG_IS_IN_PROGRESS,
  SET_DROPPABLE_CONTAINER_CURRENTLY_HOVERED_BY_DRAGGED_ITEM,
  FETCH_WORKOUT_TEMPLATE_DATA_START,
  FETCH_WORKOUT_TEMPLATE_DATA_FULFILLED,
  FETCH_WORKOUT_TEMPLATE_DATA_REJECTED,
  SET_CALENDAR_ITEMS_NAMESPACED,
  UPDATE_CALENDAR_ITEMS_ORDER_START_NAMESPACED,
  UPDATE_CALENDAR_ITEMS_ORDER_FULFILLED_NAMESPACED,
  UPDATE_CALENDAR_ITEMS_ORDER_REJECTED_NAMESPACED,
  ADD_PRESAVED_ITEM_TO_CALENDAR_ITEMS_ARRAY_NAMESPACED,
  SET_COMBINE_WITH_INFO_NAMESPACED,
  SET_PROGRAM_TYPE,
  SET_CREATE_MODAL_PROGRAM_TYPE,
  SET_PRESAVE_TABLE_LOCAL_STATE,
  REMOVE_PRESAVE_TABLE_LOCAL_STATE,
  CLEAR_PRESAVE_TABLE_LOCAL_STATE,
  SET_SELECTED_START_DAY_OF_WEEK,
  SET_SELECTED_NUMBER_OF_DAYS_TO_SHOW_IN_WEEK,
  SET_SELECTED_DAYS_OF_WEEK_TO_SHOW_IN_CURRENT_WEEK,
  SET_GROUP_BY_FILTER,
  SET_VIEW_TYPE,
  SET_CURRENTLY_DISPLAYED_WEEKDAYS,
  SET_SELECTED_WEEK_VIEW_DAY_TOGGLE,
  FETCH_FUTURE_OCCURRENCES_COUNT_START,
  FETCH_FUTURE_OCCURRENCES_COUNT_FULFILLED,
  FETCH_FUTURE_OCCURRENCES_COUNT_REJECTED,
} from './actionTypes';

const initialState = {
  programType: 'calendar',
  viewType: 'dayView',
  createModalProgramType: 'calendar',
  selectedWeekViewDayToggle: 'Everyday',
  placeholderInfo: null,
  dragIsInProgress: false,
  droppableIds: [],
  animatedSidebarContainerWidth: null,
  droppableContainerCurrentlyHoveredByDraggedItem: null,
  sideBarExerciseSearchTerm: null,
  exercisePickerSearchTerm: null,
  isCalendarOptionsDropdownMenuOpen: false,
  isStaticAddColumnDropdownMenuOpen: false,
  isBeforeRecurringSectionExpanded: false,
  isAfterRecurringSectionExpanded: false,
  isAthleteAddedItemsSectionExpanded: false,
  isSupersetPickerOpen: false,
  selectedDate: moment(),
  selectedProgramDayNumber: 0,
  itemIndexForSelectedProgramDayNumber: 0,
  selectedMonth: moment().month() + 1,
  firstMonthInPicker: moment().startOf('month').toDate(),
  calendar: [],
  workoutCalendar: [],
  combineWithInfo: null,
  isPrimaryAnimatedSideBarOpen: false,
  primarySideBarDataTag: null,
  secondarySideBarDataTag: null,
  activeModal: '',
  modalData: null,
  activeSecondLayerModal: '',
  selectedReduxCalendar: {},
  selectedReduxAthlete: {},
  selectedReduxNonDateBasedProgram: {},
  isCloneDragging: false,
  onBeforeCapture: false,
  calendarContainerScrollPosition: null,
  combineWithId: null,
  calendarPanelContainerWidth: 0,
  headerHeight: null,
  allExercises: [],
  recentlyFetchedExercise: null,
  newlyCreatedExercise: null,
  calendarItems: {},
  calendarItemsDateRange: {
    earliest: null,
    latest: null,
  },
  nonDateBasedProgramItems: [],
  mostRecentlyAddedCalendarItem: null,
  calendarPickerItems: [],
  selectedItems: {},
  copiedSelectedItems: null,
  expandedItems: {},
  weekViewExpandedDay: null,
  focusTarget: null,
  activeExerciseId: null,
  addInfoContent: {},
  iframelyError: null,
  uploadedMedia: null,
  documents: [],
  folderDocuments: [],
  fetchedDocument: null,
  addAsset: null,
  parentCalendars: [],
  calendarSelectAthletes: [],
  clickedUpgradeNow: false,
  newPreSaveItemFromCreateExerciseForm: null,
  tagsForAccount: [],
  newlyCreatedTag: null,
  calendarContainerScrollPositionTop: 0,
  // preSaveAddInfo: {},
  preSaveAddInfo: [],
  preSaveDescription: [],
  questionsForAccount: [],
  newlyCreatedQuestion: null,
  questionCount: [{
    index: 0, id: `${generateUniqueId()}-null`, isNullValue: true, isVisible: true,
  }],
  deleteStack: [],
  beforeRecurringWorkouts: {},
  afterRecurringWorkouts: {},
  recurringItemsDateRange: {
    earliest: null,
    latest: null,
  },
  shouldUpdateRecurring: true,
  isDragging: false,
  dragSource: null,
  draggedItem: null,
  templates: [],
  calendarItemContainers: {
    programmedCalendarItems: [],
    liftCalendarItems: [],
    warmUpCalendarItems: [],
    SAQCCalendarItems: [],
    circuitCalendarItems: [],
    noteCalendarItems: [],
    questionnaireCalendarItems: [],
    coolDownCalendarItems: [],
    healthCalendarItems: [],
    progressionCalendarItems: [],
    tagCalendarItems: [],
    accessoryCalendarItems: [],
  },
  savedWorkouts: [],
  selectedSavedWorkout: null,
  isLoadingSavedWorkout: false,
  savedWorkoutError: null,
  lastUpdateTime: null,
  sharedWorkoutInfo: null,
  superSetPicker: null,
  workoutTemplateData: {},
  isLoadingWorkoutTemplateData: false,
  workoutTemplateDataError: null,
  preSaveTableLocalState: {},
  currentlyDisplayedWeekdays: [],
  selectedStartDayOfWeek: 'Sunday',
  selectedNumberOfDaysToShowInWeek: 7,
  selectedDaysOfWeekToShowInCurrentWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Empty Days', 'Weekends'],
  groupByFilter: 'Week',
  newlyCreatedCalendar: null,
  futureOccurrencesCount: null,
  swapDropdownToggleEnabled: false,
  undoDeleteMetadata: {},
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CAL_WORKOUT_CALENDAR_START: {
      return {
        ...state,
        workoutCalendar: [],
      };
    }
    case FETCH_CAL_WORKOUT_CALENDAR_FULFILLED: {
      return {
        ...state,
        workoutCalendar: action.payload,
      };
    }
    case FETCH_PARENT_CALENDARS_FULFILLED: {
      return {
        ...state,
        parentCalendars: action.payload.data,
      };
    }
    case FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_FULFILLED: {
      return {
        ...state,
        questionsForAccount: action.payload,
      };
    }
    case CREATE_QUESTION_FOR_ACCOUNT_FULTILLED: {
      return {
        ...state,
        newlyCreatedQuestion: action.payload,
      };
    }
    case CLEAR_NEWLY_CREATED_QUESTION: {
      return {
        ...state,
        newlyCreatedQuestion: null,
      };
    }
    case FETCH_PARENT_CALENDARS_REJECTED: {
      return {
        ...state,
        calendarsError: action.payload,
      };
    }
    case FETCH_CAL_WORKOUT_CALENDAR_REJECTED: {
      return {
        ...state,
        workoutCalendarError: action.payload,
      };
    }
    case SET_CLICKED_UPGRADE_NOW: {
      return {
        ...state,
        clickedUpgradeNow: action.payload,
      };
    }
    case SET_PROGRAM_TYPE: {
      return {
        ...state,
        programType: action.payload,
      };
    }
    case SET_CREATE_MODAL_PROGRAM_TYPE: {
      return {
        ...state,
        createModalProgramType: action.payload,
      };
    }
    case SET_IS_BEFORE_RECURRING_SECTION_EXPANDED: {
      return {
        ...state,
        isBeforeRecurringSectionExpanded: action.payload,
      };
    }
    case SET_IS_AFTER_RECURRING_SECTION_EXPANDED: {
      return {
        ...state,
        isAfterRecurringSectionExpanded: action.payload,
      };
    }
    case SET_IS_ATHLETE_ADDED_ITEMS_SECTION_EXPANDED: {
      return {
        ...state,
        isAthleteAddedItemsSectionExpanded: action.payload,
      };
    }
    case CLEAR_MOST_RECENTLY_ADDED_CALENDAR_ITEM_TRACKER: {
      return {
        ...state,
        mostRecentlyAddedCalendarItem: null,
      };
    }
    case SET_IS_CALENDAR_OPTIONS_DROPDOWN_MENU_OPEN: {
      return {
        ...state,
        isCalendarOptionsDropdownMenuOpen: action.payload,
      };
    }
    case SET_IS_STATIC_ADD_COLUMN_DROPDOWN_MENU_OPEN: {
      return {
        ...state,
        isStaticAddColumnDropdownMenuOpen: action.payload,
      };
    }
    case SET_IS_SUPERSET_PICKER_OPEN: {
      return {
        ...state,
        isSupersetPickerOpen: action.payload,
      };
    }
    case SET_SUPERSET_PICKER_OPEN_BY_ID: {
      return {
        ...state,
        isSupersetPickerOpen: {
          ...state.isSupersetPickerOpen,
          [action.payload]: true,
        },
      };
    }
    case REMOVE_SUPERSET_PICKER_OPEN_BY_ID: {
      const { [action.payload]: _, ...rest } = state.isSupersetPickerOpen;
      return {
        ...state,
        isSupersetPickerOpen: rest,
      };
    }
    case SET_COMBINE_WITH_INFO: {
      return {
        ...state,
        combineWithInfo: action.payload,
      };
    }
    case SET_SUPERSET_PICKER: {
      return {
        ...state,
        superSetPicker: action.payload,
      };
    }
    case SET_CALENDAR_CONTENT_SCROLL_CONTAINER_TOP_POSITION: {
      return {
        ...state,
        calendarContainerScrollPositionTop: action.payload,
      };
    }
    case SET_IS_PRIMARY_ANIMATED_SIDE_BAR_OPEN: {
      return {
        ...state,
        isPrimaryAnimatedSideBarOpen: action.payload,
      };
    }
    case SET_SWAP_DROPDOWN_TOGGLE_ENABLED: {
      return {
        ...state,
        swapDropdownToggleEnabled: action.payload,
      };
    }
    case SET_PRIMARY_SIDE_BAR_DATA_TAG: {
      return {
        ...state,
        primarySideBarDataTag: action.payload,
      };
    }
    case SET_SECONDARY_SIDE_BAR_DATA_TAG: {
      return {
        ...state,
        secondarySideBarDataTag: action.payload,
      };
    }
    case SET_NEW_PRESAVE_ITEM_FROM_CREATE_EXERCISE_FORM: {
      return {
        ...state,
        newPreSaveItemFromCreateExerciseForm: action.payload,
      };
    }
    case SET_QUESTION_COUNT: {
      return {
        ...state,
        questionCount: action.payload,
      };
    }
    case SET_ACTIVE_MODAL: {
      return {
        ...state,
        activeModal: action.payload.modalType,
        modalData: action.payload.modalData,
      };
    }
    case SET_ACTIVE_SECOND_LAYER_MODAL: {
      return {
        ...state,
        activeSecondLayerModal: action.payload,
      };
    }
    case SET_SELECTED_REDUX_CALENDAR: {
      return {
        ...state,
        selectedReduxCalendar: action.payload,
        selectedReduxAthlete: {},
        activeModal: '',
        shouldUpdateRecurring: true,
        calendarItems: {},
        calendarItemsDateRange: {
          earliest: null,
          latest: null,
        },
        recurringItemsDateRange: {
          earliest: null,
          latest: null,
        },
      };
    }
    case SET_SELECTED_REDUX_ATHLETE: {
      return {
        ...state,
        selectedReduxAthlete: action.payload,
        selectedReduxCalendar: {},
        activeModal: '',
        shouldUpdateRecurring: true,
        calendarItems: {},
        calendarItemsDateRange: {
          earliest: null,
          latest: null,
        },
        recurringItemsDateRange: {
          earliest: null,
          latest: null,
        },
      };
    }
    case SET_SELECTED_REDUX_NON_DATE_BASED_PROGRAM: {
      return {
        ...state,
        /** spreading this and making new reference so it always trigger a change */
        // selectedReduxNonDateBasedProgram: { ...action.payload },
        selectedReduxNonDateBasedProgram: action.payload,
        selectedReduxAthlete: {},
        selectedReduxCalendar: {},
        activeModal: '',
        shouldUpdateRecurring: true,
        selectedItems: {},
        expandedItems: {},
        weekViewExpandedDay: null,
      };
    }
    case SET_SELECTED_SAVED_WORKOUT: {
      return {
        ...state,
        selectedSavedWorkout: action.payload,
      };
    }
    case SET_SELECTED_DATE: {
      return {
        ...state,
        selectedDate: action.payload,
        shouldUpdateRecurring: true,
        weekViewExpandedDay: null,
      };
    }
    case SET_CURRENTLY_DISPLAYED_WEEKDAYS: {
      return {
        ...state,
        currentlyDisplayedWeekdays: action.payload,
      };
    }
    case SET_SELECTED_WEEK_VIEW_DAY_TOGGLE: {
      return {
        ...state,
        selectedWeekViewDayToggle: action.payload,
      };
    }
    case SET_SELECTED_START_DAY_OF_WEEK: {
      return {
        ...state,
        selectedStartDayOfWeek: action.payload,
      };
    }
    case SET_SELECTED_NUMBER_OF_DAYS_TO_SHOW_IN_WEEK: {
      return {
        ...state,
        selectedNumberOfDaysToShowInWeek: action.payload,
      };
    }
    case SET_SELECTED_DAYS_OF_WEEK_TO_SHOW_IN_CURRENT_WEEK: {
      return {
        ...state,
        selectedDaysOfWeekToShowInCurrentWeek: action.payload,
      };
    }
    case SET_GROUP_BY_FILTER: {
      return {
        ...state,
        groupByFilter: action.payload,
      };
    }
    case SET_SELECTED_PROGRAM_DAY_NUMBER: {
      return {
        ...state,
        selectedProgramDayNumber: action.payload,
      };
    }
    case SET_SELECTED_MONTH: {
      return {
        ...state,
        selectedMonth: action.payload,
      };
    }
    case SET_FIRST_MONTH_IN_PICKER: {
      return {
        ...state,
        firstMonthInPicker: action.payload,
      };
    }

    case SET_ACTIVE_EXERCISE_ID: {
      return {
        ...state,
        activeExerciseId: action.payload,
      };
    }
    case SET_SELECTED_ITEMS: {
      return {
        ...state,
        selectedItems: action.payload,
      };
    }
    case SET_SELECTED_ITEM: {
      return {
        ...state,
        selectedItems: {
          ...state.selectedItems,
          [action.payload.assignedId]: action.payload,
        },
      };
    }

    case REMOVE_SELECTED_ITEM: {
      const { [action.payload.assignedId]: _, ...rest } = state.selectedItems;
      return {
        ...state,
        selectedItems: rest,
      };
    }
    case SET_COPIED_SELECTED_ITEMS: {
      return {
        ...state,
        copiedSelectedItems: action.payload,
      };
    }
    case SET_EXPANDED_ITEMS: {
      return {
        ...state,
        expandedItems: action.payload,
      };
    }

    case SET_EXPANDED_ITEM: {
      return {
        ...state,
        expandedItems: {
          ...state.expandedItems,
          [action.payload.assignedId]: action.payload,
        },
      };
    }

    case REMOVE_EXPANDED_ITEM: {
      const { [action.payload.assignedId]: _, ...rest } = state.expandedItems;
      return {
        ...state,
        expandedItems: rest,
      };
    }

    case SET_WEEK_VIEW_EXPANDED_DAY: {
      return {
        ...state,
        weekViewExpandedDay: action.payload,
        selectedItems: {},
      };
    }
    // This case statement handles the action to focus on the next preSave item in the calendar.
    // It extracts the current index and selected date from the action payload, formats the date,
    // and retrieves the list of exercises for that date. It then searches for the next item
    // marked with preSave starting from the current index. If it encounters a collapsed session
    // break, it skips over all items until the next session break. If found, it updates the state to
    // expand the next preSave item and sets the focus target to this item, including its index,
    // assigned ID, and a timestamp. If no such item is found, the state remains unchanged.
    case FOCUS_NEXT_PRESAVE_ITEM: {
      const { currentIndex, selectedDate } = action.payload;
      const formattedDate = moment(selectedDate).format('YYYY-MM-DD');
      const calendarItems = state.calendarItems[formattedDate]?.exercises || [];

      // Find next preSave item starting from currentIndex + 1
      let nextPreSaveIndex = -1;
      for (let i = currentIndex + 1; i < calendarItems.length; i += 1) {
        const currentItem = calendarItems[i];

        // Check if this is a session break
        if (currentItem?.type === 'session_break') {
          // Check if the session break is collapsed (not in expandedItems)
          if (!state.expandedItems[currentItem.assignedId]) {
            // Skip over all items until the next session break
            let nextSessionBreakIndex = -1;
            for (let j = i + 1; j < calendarItems.length; j += 1) {
              if (calendarItems[j]?.type === 'session_break') {
                nextSessionBreakIndex = j;
                break;
              }
            }

            // If we found another session break, jump to it; otherwise we're done searching
            if (nextSessionBreakIndex !== -1) {
              i = nextSessionBreakIndex - 1; // -1 because the loop will increment
            } else {
              // No more session breaks, we're done searching
              break;
            }
          }
          // If session break is expanded, we skip this iteration but continue the loop
        } else if (currentItem?.preSave === true) {
          // Check if this item is a preSave item
          nextPreSaveIndex = i;
          break;
        }
      }

      if (nextPreSaveIndex !== -1) {
        const nextItem = calendarItems[nextPreSaveIndex];
        return {
          ...state,
          expandedItems: {
            ...state.expandedItems,
            [nextItem.assignedId]: nextItem,
          },
          focusTarget: {
            itemIndex: nextPreSaveIndex,
            assignedId: nextItem.assignedId,
            timestamp: Date.now(),
          },
        };
      }

      // No more pre-save items found, focus the first focusable field in the item that was just saved
      const currentItem = calendarItems[currentIndex];
      if (currentItem) {
        return {
          ...state,
          focusTarget: {
            itemIndex: currentIndex,
            assignedId: currentItem.assignedId,
            timestamp: Date.now(),
            focusFirstField: true, // Flag to indicate we want to focus the first field
          },
        };
      }
      return state;
    }
    case FOCUS_NEXT_PRESAVE_PROGRAM_ITEM: {
      const { currentIndex, dayNumber } = action.payload;
      const programItems = state.nonDateBasedProgramItems[dayNumber]?.exercises || [];

      // Find next preSave item starting from currentIndex + 1
      let nextPreSaveIndex = -1;
      for (let i = currentIndex + 1; i < programItems.length; i += 1) {
        const currentItem = programItems[i];

        // Check if this is a session break
        if (currentItem?.type === 'session_break') {
          // Check if the session break is collapsed (not in expandedItems)
          if (!state.expandedItems[currentItem.assignedId]) {
            // Skip over all items until the next session break
            let nextSessionBreakIndex = -1;
            for (let j = i + 1; j < programItems.length; j += 1) {
              if (programItems[j]?.type === 'session_break') {
                nextSessionBreakIndex = j;
                break;
              }
            }

            // If we found another session break, jump to it; otherwise we're done searching
            if (nextSessionBreakIndex !== -1) {
              i = nextSessionBreakIndex - 1; // -1 because the loop will increment
            } else {
              // No more session breaks, we're done searching
              break;
            }
          }
          // If session break is expanded, we skip this iteration but continue the loop
        } else if (currentItem?.preSave === true) {
          // Check if this item is a preSave item
          nextPreSaveIndex = i;
          break;
        }
      }

      if (nextPreSaveIndex !== -1) {
        const nextItem = programItems[nextPreSaveIndex];
        return {
          ...state,
          expandedItems: {
            ...state.expandedItems,
            [nextItem.assignedId]: nextItem,
          },
          focusTarget: {
            itemIndex: nextPreSaveIndex,
            assignedId: nextItem.assignedId,
            timestamp: Date.now(),
          },
        };
      }

      // No more pre-save items found, focus the first focusable field in the item that was just saved
      const currentItem = programItems[currentIndex];
      if (currentItem) {
        return {
          ...state,
          focusTarget: {
            itemIndex: currentIndex,
            assignedId: currentItem.assignedId,
            timestamp: Date.now(),
            focusFirstField: true,
          },
        };
      }
      return state;
    }
    case SET_IS_CLONE_DRAGGING: {
      return {
        ...state,
        isCloneDragging: action.payload,
      };
    }
    case SET_ON_BEFORE_CAPTURE: {
      return {
        ...state,
        onBeforeCapture: action.payload,
      };
    }
    case ADD_ASSET: {
      return {
        ...state,
        addAsset: action.payload,
      };
    }
    case SET_SIDE_BAR_EXERCISES_SEARCH_TERM: {
      return {
        ...state,
        sideBarExerciseSearchTerm: action.payload,
      };
    }
    case SET_EXERCISE_PICKER_SEARCH_TERM: {
      return {
        ...state,
        exercisePickerSearchTerm: action.payload,
      };
    }
    case SET_CALENDAR_CONTAINER_SCROLL_POSITION: {
      return {
        ...state,
        calendarContainerScrollPosition: action.payload,
      };
    }
    case SET_COMBINE_WITH_ID: {
      return {
        ...state,
        combineWithId: action.payload,
      };
    }
    case SET_CALENDAR_PANEL_CONTAINER_WIDTH: {
      return {
        ...state,
        calendarPanelContainerWidth: action.payload,
      };
    }
    case SET_ANIMATED_SIDEBAR_CONTAINER_WIDTH: {
      return {
        ...state,
        animatedSidebarContainerWidth: action.payload,
      };
    }
    case SET_HEADER_HEIGHT: {
      return {
        ...state,
        headerHeight: action.payload,
      };
    }
    case SET_IFRAMELY_ERROR: {
      return {
        ...state,
        iframelyError: action.payload,
      };
    }
    case FETCH_ALL_EXERCISES_START: {
      return {
        ...state,
        allExercises: [],
      };
    }
    case FETCH_ALL_EXERCISES_FULFILLED: {
      return {
        ...state,
        allExercises: action.payload,
      };
    }
    case FETCH_ALL_EXERCISES_REJECTED: {
      return {
        ...state,
        allExercisesError: action.payload,
      };
    }
    case FETCH_EXERCISE_FULFILLED: {
      return {
        ...state,
        recentlyFetchedExercise: action.payload,
      };
    }
    case FETCH_EXERCISE_REJECTED: {
      return {
        ...state,
        recentlyFetchedExercise: null,
      };
    }
    case FETCH_CALENDAR_ITEMS_START: {
      return {
        ...state,
        // Don't clear calendarItems - keep existing data during fetch
      };
    }
    case FETCH_CALENDAR_ITEMS_FULFILLED: {
      const newData = action?.payload?.data || {};
      const requestedRange = action?.payload?.requestedRange;
      const mergedItems = {
        ...state.calendarItems,
        ...newData,
      };

      // Extend the range to include both old and new
      let newEarliest = state.calendarItemsDateRange.earliest;
      let newLatest = state.calendarItemsDateRange.latest;

      if (requestedRange) {
        if (!newEarliest || moment(requestedRange.start).isBefore(newEarliest)) {
          newEarliest = requestedRange.start;
        }
        if (!newLatest || moment(requestedRange.end).isAfter(newLatest)) {
          newLatest = requestedRange.end;
        }
      }

      return {
        ...state,
        shouldFetchRecurring: Date.now(),
        calendarItems: mergedItems,
        calendarItemsDateRange: {
          earliest: newEarliest,
          latest: newLatest,
        },
      };
    }
    case FETCH_CALENDAR_ITEMS_REJECTED: {
      return {
        ...state,
        fetchCalendarItemsError: action.payload,
      };
    }
    case FETCH_CALENDAR_SELECT_ATHLETES_START: {
      return {
        ...state,
      };
    }
    case FETCH_CALENDAR_SELECT_ATHLETES_FULFILLED: {
      return {
        ...state,
        calendarSelectAthletes: action.payload,
      };
    }
    case FETCH_CALENDAR_SELECT_ATHLETES_REJECTED: {
      return {
        ...state,
        calendarSelectAthletesError: action.payload,
      };
    }
    case ADD_PRESAVED_ITEM_TO_CALENDAR_ITEMS_ARRAY: {
      const { item } = action.payload;
      const { date } = action.payload;
      const { destinationContainerIndex } = action.payload;
      const { droppableId } = action.payload;
      /** const index = action.payload.destinationContainerIndex; */

      const actualIndex = destinationContainerIndex ?? state.calendarItems[date]?.exercises.length ?? 0;

      // Prepare focus target for the newly added item
      const focusTarget = {
        itemIndex: actualIndex,
        assignedId: item.assignedId,
        timestamp: Date.now(),
      };

      // Handle week view day expansion when dropping into week-day containers
      let updatedExpandedItems;
      let { weekViewExpandedDay } = state;

      if (droppableId && droppableId.startsWith('week-day-')) {
        // Clear expanded items in other day columns when expanding a new day
        updatedExpandedItems = {
          [item.assignedId]: item,
        };
        weekViewExpandedDay = date; // Use the date of the dropped item
      } else {
        // Normal behavior - keep existing expanded items and add the new item
        updatedExpandedItems = {
          ...state.expandedItems,
          [item.assignedId]: item,
        };
      }

      if (state.calendarItems[date]) {
        return update(state, {
          calendarItems: {
            [date]: {
              exercises: {
                $splice: [
                  [actualIndex, 0, item], // using actualIndex here
                ],
              },
            },
          },
          expandedItems: { $set: updatedExpandedItems },
          focusTarget: { $set: focusTarget },
          mostRecentlyAddedCalendarItem: { $set: item },
          weekViewExpandedDay: { $set: weekViewExpandedDay },
        });
      }
      const newCalendarItems = { ...state.calendarItems };
      newCalendarItems[date] = {
        date,
        exercises: [item],
        repCount: 0,
      };
      return {
        ...state,
        calendarItems: newCalendarItems,
        expandedItems: updatedExpandedItems,
        focusTarget,
        mostRecentlyAddedCalendarItem: item,
        weekViewExpandedDay,
      };
    }

    case ADD_PRESAVED_ITEM_TO_PROGRAM_ITEMS_ARRAY: {
      const { item } = action.payload;
      const { programDayNumber } = action.payload;
      const { destinationContainerIndex } = action.payload;
      const { droppableId } = action.payload;

      const actualIndex = destinationContainerIndex ?? state.nonDateBasedProgramItems[programDayNumber]?.exercises?.length ?? 0;

      /** Prepare focus target for the newly added item */
      const focusTarget = {
        itemIndex: actualIndex,
        assignedId: item.assignedId,
        timestamp: Date.now(),
      };

      /** Handle week view day expansion when dropping into week-day containers */
      let updatedExpandedItems;
      let { weekViewExpandedDay } = state;

      if (droppableId && droppableId.startsWith('week-day-')) {
        /** Clear expanded items in other day columns when expanding a new day */
        updatedExpandedItems = {
          [item.assignedId]: item,
        };
        weekViewExpandedDay = Number(programDayNumber); // Use the date of the dropped item
      } else {
        /** Normal behavior - keep existing expanded items and add the new item */
        updatedExpandedItems = {
          ...state.expandedItems,
          [item.assignedId]: item,
        };
      }
      if (state.nonDateBasedProgramItems[programDayNumber]) {
        return update(state, {
          nonDateBasedProgramItems: {
            [programDayNumber]: {
              exercises: {
                $apply: (arr = []) => {
                  arr.splice(actualIndex, 0, item);
                  return arr;
                },
              },
            },
          },
          expandedItems: { $set: updatedExpandedItems },
          focusTarget: { $set: focusTarget },
          mostRecentlyAddedCalendarItem: { $set: item },
          weekViewExpandedDay: { $set: weekViewExpandedDay },
        });
      }
      const newProgramItems = { ...state.nonDateBasedProgramItems };
      newProgramItems[programDayNumber] = {
        programDayNumber,
        exercises: [item],
        repCount: 0,
      };
      return {
        ...state,
        nonDateBasedProgramItems: newProgramItems,
        expandedItems: updatedExpandedItems,
        focusTarget,
        mostRecentlyAddedCalendarItem: item,
        weekViewExpandedDay,
      };
    }

    case SAVE_CALENDAR_EXERCISE_FULFILLED: {
      const newItem = action.payload.data;
      const { preSwappedAssignedId } = action.payload;
      const { selectedItems, expandedItems } = state;

      /** --- Update selectedItems dictionary --- */
      let updatedSelectedItems = selectedItems;

      /** If the old item was selected, replace it with the new item */
      if (selectedItems[preSwappedAssignedId]) {
        const { [preSwappedAssignedId]: _, ...restSelectedItems } = selectedItems;
        updatedSelectedItems = {
          ...restSelectedItems,
          [newItem.assignedId]: newItem,
        };
      }

      const updatedExpandedItems = {
        ...expandedItems,
        /** if newItem type is a questionnaire, add it as expanded, else add the new item as collapsed */
        [newItem.assignedId]: newItem?.type === 'questionnaire',
      };

      if (state.calendarItems[action.payload.formattedDate]) {
        const { formattedDate, itemIndex } = action.payload;
        const currentExercises = state.calendarItems[formattedDate]?.exercises || [];

        // Calculate date-level totals after updating this exercise
        const { dateSetCount, dateRepCount } = currentExercises.reduce(
          (totals, exercise, index) => {
            const exerciseToUse = index === itemIndex ? newItem : exercise;
            return {
              dateSetCount: totals.dateSetCount + (exerciseToUse.setCount || 0),
              dateRepCount: totals.dateRepCount + (exerciseToUse.repCount || 0),
            };
          },
          { dateSetCount: 0, dateRepCount: 0 },
        );

        return update(state, {
          calendarItems: {
            [formattedDate]: {
              exercises: {
                [itemIndex]: {
                  $set: newItem,
                },
              },
              setCount: {
                $set: dateSetCount,
              },
              repCount: {
                $set: dateRepCount,
              },
              lastUpdatedTimestamp: {
                $set: Date.now(),
              },
            },
          },
          selectedItems: { $set: updatedSelectedItems },
          expandedItems: { $set: updatedExpandedItems },
          mostRecentlyAddedCalendarItem: { $set: newItem },
          shouldFetchRecurring: { $set: Date.now() },
        });
      }
      const newDate = action.payload.formattedDate;
      const newExercises = [action.payload.data];

      // Calculate date-level totals from all exercises for this new date
      const { dateSetCount, dateRepCount } = newExercises.reduce(
        (totals, exercise) => ({
          dateSetCount: totals.dateSetCount + (exercise.setCount || 0),
          dateRepCount: totals.dateRepCount + (exercise.repCount || 0),
        }),
        { dateSetCount: 0, dateRepCount: 0 },
      );

      const newCalendarItems = { ...state.calendarItems };
      newCalendarItems[newDate] = {
        date: newDate,
        exercises: newExercises,
        setCount: dateSetCount,
        repCount: dateRepCount,
        lastUpdatedTimestamp: Date.now(),
      };

      return {
        ...state,
        calendarItems: newCalendarItems,
        mostRecentlyAddedCalendarItem: newItem,
      };
    }

    case SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_FULFILLED: {
      const newItem = action.payload.data;
      const { preSwappedAssignedId } = action.payload;
      const { selectedItems, expandedItems } = state;

      /** --- Update selectedItems dictionary --- */
      let updatedSelectedItems = selectedItems;

      /** If the old item was selected, replace it with the new item */
      if (selectedItems[preSwappedAssignedId]) {
        const { [preSwappedAssignedId]: _, ...restSelectedItems } = selectedItems;
        updatedSelectedItems = {
          ...restSelectedItems,
          [newItem.assignedId]: newItem,
        };
      }

      const updatedExpandedItems = {
        ...expandedItems,
        /** if newItem type is a questionnaire, add it as expanded, else add the new item as collapsed */
        [newItem.assignedId]: newItem?.type === 'questionnaire',
      };

      if (state.nonDateBasedProgramItems[action.payload.dayNumber]) {
        const { dayNumber, itemIndex } = action.payload;
        const currentExercises = state.nonDateBasedProgramItems[dayNumber]?.exercises || [];

        // Calculate date-level totals after updating this exercise
        const { dateSetCount, dateRepCount } = currentExercises.reduce(
          (totals, exercise, index) => {
            const exerciseToUse = index === itemIndex ? newItem : exercise;
            return {
              dateSetCount: totals.dateSetCount + (exerciseToUse.setCount || 0),
              dateRepCount: totals.dateRepCount + (exerciseToUse.repCount || 0),
            };
          },
          { dateSetCount: 0, dateRepCount: 0 },
        );

        return update(state, {
          nonDateBasedProgramItems: {
            [dayNumber]: {
              exercises: {
                [itemIndex]: {
                  $set: newItem,
                },
              },
              setCount: {
                $set: dateSetCount,
              },
              repCount: {
                $set: dateRepCount,
              },
              lastUpdatedTimestamp: {
                $set: Date.now(),
              },
            },
          },
          selectedItems: { $set: updatedSelectedItems },
          expandedItems: { $set: updatedExpandedItems },
          mostRecentlyAddedCalendarItem: { $set: newItem },
        });
      }
      // const newDate = action.payload.formattedDate;
      const newDay = action.payload.dayNumber;
      const newExercises = [action.payload.data];

      // Calculate date-level totals from all exercises for this new date
      const { dateSetCount, dateRepCount } = newExercises.reduce(
        (totals, exercise) => ({
          dateSetCount: totals.dateSetCount + (exercise.setCount || 0),
          dateRepCount: totals.dateRepCount + (exercise.repCount || 0),
        }),
        { dateSetCount: 0, dateRepCount: 0 },
      );

      const newProgramItems = { ...state.nonDateBasedProgramItems };
      newProgramItems[newDay] = {
        dayInWeek: action.payload.data.dayInWeek,
        dayNumber: newDay,
        exercises: newExercises,
        repCount: dateRepCount,
        setCount: dateSetCount,
        weekNumber: action.payload.data.weekNumber,
        lastUpdatedTimestamp: Date.now(),
      };

      return {
        ...state,
        nonDateBasedProgramItems: newProgramItems,
        mostRecentlyAddedCalendarItem: newItem,
      };
    }
    case SET_CALENDAR_ITEMS: {
      // Ensure the date object exists before updating
      const dateExists = state.calendarItems[action.payload.date];
      if (!dateExists) {
        return update(state, {
          calendarItems: {
            [action.payload.date]: {
              $set: {
                exercises: action.payload.calendarItemsArray,
              },
            },
          },
        });
      }
      return update(state, {
        calendarItems: {
          [action.payload.date]: {
            exercises: {
              $set: action.payload.calendarItemsArray,
            },
          },
        },
      });
    }
    case SET_NON_DATE_BASED_PROGRAM_DAYS: {
      return {
        ...state,
        nonDateBasedProgramItems: action.payload.programDays,
      };
    }
    case SET_NON_DATE_BASED_PROGRAM_ITEMS: {
      // Ensure the day number object exists before updating
      const programDayNumberExists = state.nonDateBasedProgramItems[action.payload.programDayNumber];
      if (!programDayNumberExists) {
        return update(state, {
          nonDateBasedProgramItems: {
            [action.payload.programDayNumber]: {
              $set: {
                exercises: action.payload.programItemsArray,
              },
            },
          },
        });
      }
      return update(state, {
        nonDateBasedProgramItems: {
          [action.payload.programDayNumber]: {
            exercises: {
              $set: action.payload.programItemsArray,
            },
          },
        },
      });
    }

    case SET_RECURRING_CALENDAR_ITEMS: {
      const { beforeOrAfter } = action.payload;
      if (beforeOrAfter === 'before') {
        return update(state, {
          beforeRecurringWorkouts: {
            [action.payload.formattedDate]: {
              $set: action.payload.calendarItemsArray,
            },
          },
        });
      }
      if (beforeOrAfter === 'after') {
        return update(state, {
          afterRecurringWorkouts: {
            [action.payload.formattedDate]: {
              $set: action.payload.calendarItemsArray,
            },
          },
        });
      }
      return {
        ...state,
      };
    }

    case CLEAR_BEFORE_RECURRING_CALENDAR_ITEMS: {
      return {
        ...state,
        beforeRecurringWorkouts: {},
      };
    }

    case CLEAR_AFTER_RECURRING_CALENDAR_ITEMS: {
      return {
        ...state,
        afterRecurringWorkouts: {},
      };
    }

    case CLEAR_CALENDAR_ITEMS: {
      return {
        ...state,
        calendarItems: {},
      };
    }
    case CLEAR_NON_DATE_BASED_PROGRAM_ITEMS: {
      return {
        ...state,
        nonDateBasedProgramItems: [],
      };
    }
    case SAVE_CALENDAR_EXERCISE_REJECTED: {
      return {
        ...state,
        fetchCalendarItemsError: action.payload,
      };
    }
    case UPLOAD_CALENDAR_MEDIA_FULFILLED: {
      return {
        ...state,
        uploadedMedia: action.payload,
      };
    }
    case UPLOAD_CALENDAR_MEDIA_REJECTED: {
      return {
        ...state,
        uploadedMedia: null,
      };
    }
    case EDIT_THUMBNAIL_FULFUILLED: {
      return {
        ...state,
        /** replace current uploadedMedia with edited thumbnail media */
        uploadedMedia: action.payload,
      };
    }
    case CREATE_EXERCISE_FULFILLED: {
      return {
        ...state,
        allExercises: [
          ...state.allExercises,
          action.payload,
        ].sort((a, b) => a.name.localeCompare(b.name)), /** Sort alphabetically by `name` */
        newlyCreatedExercise: action.payload,
      };
    }
    case CREATE_TAG_FOR_ACCOUNT_FULTILLED: {
      return {
        ...state,
        tagsForAccount: [...state.tagsForAccount, action.payload],
        newlyCreatedTag: action.payload,
      };
    }
    case FETCH_ACCOUNT_TAGS_FULFILLED: {
      return {
        ...state,
        tagsForAccount: action.payload,
      };
    }
    case SET_ADD_INFO_CONTENT: {
      return {
        ...state,
        addInfoContent: action.payload,
      };
    }
    case FETCH_DOCUMENTS_FULFILLED: {
      return {
        ...state,
        documents: action.payload,
      };
    }
    case FETCH_DOCUMENT_FULFILLED: {
      return {
        ...state,
        fetchedDocument: action.payload,
      };
    }
    case FETCH_FOLDER_FULFILLED: {
      return {
        ...state,
        folderDocuments: action.payload,
      };
    }
    case UPDATE_SAVED_WORKOUT_ITEM_FULFILLED: {
      const newItem = action.payload.data;
      const { dayNumber, itemIndex } = action.payload;
      const currentExercises = state.nonDateBasedProgramItems[dayNumber]?.exercises || [];

      // Calculate date-level totals after updating this exercise
      const { dateSetCount, dateRepCount } = currentExercises.reduce(
        (totals, exercise, index) => {
          const exerciseToUse = index === itemIndex ? newItem : exercise;
          return {
            dateSetCount: totals.dateSetCount + (exerciseToUse.setCount || 0),
            dateRepCount: totals.dateRepCount + (exerciseToUse.repCount || 0),
          };
        },
        { dateSetCount: 0, dateRepCount: 0 },
      );

      return update(state, {
        nonDateBasedProgramItems: {
          [dayNumber]: {
            exercises: {
              [itemIndex]: {
                $set: newItem,
              },
            },
            setCount: {
              $set: dateSetCount,
            },
            repCount: {
              $set: dateRepCount,
            },
            lastUpdatedTimestamp: {
              $set: Date.now(),
            },
          },
        },
      });
    }
    case UPDATE_PROGRAMMED_CALENDAR_ITEM_FULFILLED: {
      const newItem = action.payload.data;
      if (action.payload.isRecurring && action.payload.isRecurring === 'before') {
        return update(state, {
          beforeRecurringWorkouts: {
            [action.payload.formattedDate]: {
              [action.payload.itemIndex]: {
                $set: newItem,
              },
            },
          },
        });
      }
      if (action.payload.isRecurring && action.payload.isRecurring === 'after') {
        return update(state, {
          afterRecurringWorkouts: {
            [action.payload.formattedDate]: {
              [action.payload.itemIndex]: {
                $set: newItem,
              },
            },
          },
        });
      }
      const { formattedDate, itemIndex } = action.payload;
      const currentExercises = state.calendarItems[formattedDate]?.exercises || [];

      // Calculate date-level totals after updating this exercise
      const { dateSetCount, dateRepCount } = currentExercises.reduce(
        (totals, exercise, index) => {
          const exerciseToUse = index === itemIndex ? newItem : exercise;
          return {
            dateSetCount: totals.dateSetCount + (exerciseToUse.setCount || 0),
            dateRepCount: totals.dateRepCount + (exerciseToUse.repCount || 0),
          };
        },
        { dateSetCount: 0, dateRepCount: 0 },
      );

      return update(state, {
        calendarItems: {
          [formattedDate]: {
            exercises: {
              [itemIndex]: {
                $set: newItem,
              },
            },
            setCount: {
              $set: dateSetCount,
            },
            repCount: {
              $set: dateRepCount,
            },
            lastUpdatedTimestamp: {
              $set: Date.now(),
            },
          },
        },
      });
    }
    case SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_FULFILLED: {
      const newItem = action.payload.data;
      const { preSwappedAssignedId } = action.payload;
      const { selectedItems, expandedItems } = state;

      /** --- Update selectedItems dictionary --- */
      let updatedSelectedItems = selectedItems;

      /** If the old item was selected, replace it with the new item */
      if (selectedItems[preSwappedAssignedId]) {
        const { [preSwappedAssignedId]: _, ...restSelectedItems } = selectedItems;
        updatedSelectedItems = {
          ...restSelectedItems,
          [newItem.assignedId]: newItem,
        };
      }

      /** Update expandedItems object */
      /** if the pre swapped assigned id was in the expandedItems object
       * then the new swapped item should be expanded because we are updating
       * an item that is expanded.
       */
      const updatedExpandedItems = { ...expandedItems };

      if (updatedExpandedItems[preSwappedAssignedId] !== undefined) {
        updatedExpandedItems[newItem.assignedId] = updatedExpandedItems[preSwappedAssignedId];
      }
      return update(state, {
        calendarItems: {
          [action.payload.formattedDate]: {
            exercises: {
              [action.payload.itemIndex]: {
                $set: newItem,
              },
            },
          },
        },
        selectedItems: { $set: updatedSelectedItems },
        expandedItems: { $set: updatedExpandedItems },
      });
    }

    case REVERT_SWAPPED_ITEM_FULFILLED: {
      const newItem = action.payload.data;
      const { preRevertedAssignedId } = action.payload;
      const { selectedItems, expandedItems } = state;

      /** --- Update selectedItems dictionary --- */
      let updatedSelectedItems = selectedItems;

      /** If the old item was selected, replace it with the new item */
      if (selectedItems[preRevertedAssignedId]) {
        const { [preRevertedAssignedId]: _, ...restSelectedItems } = selectedItems;
        updatedSelectedItems = {
          ...restSelectedItems,
          [newItem.assignedId]: newItem,
        };
      }

      /** Update expandedItems object */
      /** if the pre swapped assigned id was in the expandedItems object
       * then the new swapped item should be expanded because we are updating
       * an item that is expanded.
       */
      const updatedExpandedItems = { ...expandedItems };

      if (updatedExpandedItems[preRevertedAssignedId] !== undefined) {
        updatedExpandedItems[newItem.assignedId] = updatedExpandedItems[preRevertedAssignedId];
      }
      return update(state, {
        calendarItems: {
          [action.payload.formattedDate]: {
            exercises: {
              [action.payload.itemIndex]: {
                $set: newItem,
              },
            },
          },
        },
        selectedItems: { $set: updatedSelectedItems },
        expandedItems: { $set: updatedExpandedItems },
      });
    }
    case UPDATE_PRESAVED_CALENDAR_ITEM: {
      const updatedItem = action.payload.item;
      return update(state, {
        calendarItems: {
          [action.payload.date]: {
            exercises: {
              [action.payload.destinationContainerIndex]: {
                $set: updatedItem,
              },
            },
          },
        },
      });
    }

    case UPDATE_PRESAVED_PROGRAM_ITEM: {
      const updatedItem = action.payload.item;
      return update(state, {
        nonDateBasedProgramItems: {
          [action.payload.programDayNumber]: {
            exercises: {
              [action.payload.destinationContainerIndex]: {
                $set: updatedItem,
              },
            },
          },
        },
      });
    }

    case DELETE_RECURRING_ITEM_FULFILLED: {
      return state;
    }

    case DELETE_SAVED_CALENDAR_ITEM_FULFILLED: {
      const { date, assignedIds } = action.payload.data;

      const removeByAssignedIds = (items) => items.filter(
        (item) => !assignedIds.includes(item.assignedId),
      );

      /** Remove deleted items from selectedItems */
      const updatedSelectedItems = { ...state.selectedItems };
      assignedIds.forEach((id) => {
        delete updatedSelectedItems[id];
      });

      /** Capture deleted items with their indices for undo */
      const currentExercises = state.calendarItems[date]?.exercises || [];
      const deletedItemsWithIndices = [];
      currentExercises.forEach((item, idx) => {
        if (assignedIds.includes(item.assignedId)) {
          deletedItemsWithIndices.push({ item, index: idx });
        }
      });

      const remainingExercises = removeByAssignedIds(currentExercises);

      // Calculate date-level totals from remaining exercises
      const { dateSetCount, dateRepCount } = remainingExercises.reduce(
        (totals, exercise) => ({
          dateSetCount: totals.dateSetCount + (exercise.setCount || 0),
          dateRepCount: totals.dateRepCount + (exercise.repCount || 0),
        }),
        { dateSetCount: 0, dateRepCount: 0 },
      );

      return update(state, {
        calendarItems: {
          [date]: {
            exercises: {
              $apply: removeByAssignedIds,
            },
            setCount: {
              $set: dateSetCount,
            },
            repCount: {
              $set: dateRepCount,
            },
          },
        },
        selectedItems: { $set: updatedSelectedItems },
        shouldFetchRecurring: { $set: Date.now() },
        undoDeleteMetadata: {
          [[...assignedIds].sort().join(',')]: {
            $set: { kind: 'calendar', date, deletedItemsWithIndices },
          },
        },
      });
    }
    case DELETE_SAVED_WORKOUT_ITEM_FULFILLED: {
      const { dayNumber, assignedIds } = action.payload.data;

      const removeByAssignedIds = (items) => items.filter((item) => !assignedIds.includes(item.assignedId));

      /** Calculate updated totals after deletion */
      const currentExercises = state.nonDateBasedProgramItems[dayNumber]?.exercises || [];
      const remainingExercises = removeByAssignedIds(currentExercises);

      /** Capture deleted items with their original indices for undo */
      const deletedItemsWithIndices = [];
      currentExercises.forEach((item, idx) => {
        if (assignedIds.includes(item.assignedId)) {
          deletedItemsWithIndices.push({ item, index: idx });
        }
      });

      /** Remove deleted items from selectedItems */
      const updatedSelectedItems = { ...state.selectedItems };
      assignedIds.forEach((id) => {
        delete updatedSelectedItems[id];
      });

      /** Calculate date-level totals from remaining exercises */
      const { dateSetCount, dateRepCount } = remainingExercises.reduce(
        (totals, exercise) => ({
          dateSetCount: totals.dateSetCount + (exercise.setCount || 0),
          dateRepCount: totals.dateRepCount + (exercise.repCount || 0),
        }),
        { dateSetCount: 0, dateRepCount: 0 },
      );

      return update(state, {
        nonDateBasedProgramItems: {
          [dayNumber]: {
            exercises: {
              $apply: removeByAssignedIds,
            },
            setCount: {
              $set: dateSetCount,
            },
            repCount: {
              $set: dateRepCount,
            },
          },
        },
        selectedItems: { $set: updatedSelectedItems },
        undoDeleteMetadata: {
          [[...assignedIds].sort().join(',')]: {
            $set: { kind: 'workout', dayNumber, deletedItemsWithIndices },
          },
        },
      });
    }
    case UNDO_DELETE_SAVED_WORKOUT_ITEM_FULFILLED: {
      const restoredItems = action.payload.data;
      const { assignedIds } = action.payload;
      const metadataKey = assignedIds ? [...assignedIds].sort().join(',') : null;
      const metadata = metadataKey ? state.undoDeleteMetadata[metadataKey] : null;

      if (!metadata || metadata.kind !== 'workout' || !restoredItems?.length) {
        return metadataKey
          ? update(state, { undoDeleteMetadata: { $unset: [metadataKey] } })
          : state;
      }

      const { dayNumber, deletedItemsWithIndices } = metadata;
      const exercises = [...(state.nonDateBasedProgramItems[dayNumber]?.exercises || [])];

      /** Reinsert each restored item at its original index, adjusting for any
       * items not returned by the API to keep subsequent positions correct */
      let skipped = 0;
      deletedItemsWithIndices.forEach(({ item, index }) => {
        const restoredItem = restoredItems.find((r) => r.assignedId === item.assignedId);
        if (restoredItem) {
          const insertAt = Math.min(index - skipped, exercises.length);
          exercises.splice(insertAt, 0, restoredItem);
        } else {
          skipped++;
        }
      });

      /** Recalculate totals */
      const { undoSetCount, undoRepCount } = exercises.reduce(
        (totals, exercise) => ({
          undoSetCount: totals.undoSetCount + (exercise.setCount || 0),
          undoRepCount: totals.undoRepCount + (exercise.repCount || 0),
        }),
        { undoSetCount: 0, undoRepCount: 0 },
      );

      return update(state, {
        nonDateBasedProgramItems: {
          [dayNumber]: {
            exercises: { $set: exercises },
            setCount: { $set: undoSetCount },
            repCount: { $set: undoRepCount },
          },
        },
        undoDeleteMetadata: { $unset: [metadataKey] },
      });
    }
    case UNDO_DELETE_SAVED_CALENDAR_ITEM_FULFILLED: {
      const restoredItems = action.payload.data;
      const { assignedIds } = action.payload;
      const metadataKey = assignedIds ? [...assignedIds].sort().join(',') : null;
      const metadata = metadataKey ? state.undoDeleteMetadata[metadataKey] : null;

      if (!metadata || metadata.kind !== 'calendar' || !restoredItems?.length) {
        return metadataKey
          ? update(state, { undoDeleteMetadata: { $unset: [metadataKey] } })
          : state;
      }

      const { date, deletedItemsWithIndices } = metadata;
      const exercises = [
        ...(state.calendarItems[date]?.exercises || []),
      ];

      /** Reinsert each restored item at its original index, adjusting for any
       * items not returned by the API to keep subsequent positions correct */
      let skipped = 0;
      deletedItemsWithIndices.forEach(({ item, index }) => {
        const restoredItem = restoredItems.find(
          (r) => r.assignedId === item.assignedId,
        );
        if (restoredItem) {
          const insertAt = Math.min(index - skipped, exercises.length);
          exercises.splice(insertAt, 0, restoredItem);
        } else {
          skipped++;
        }
      });

      /** Recalculate totals */
      const { undoSetCount, undoRepCount } = exercises.reduce(
        (totals, exercise) => ({
          undoSetCount: totals.undoSetCount + (exercise.setCount || 0),
          undoRepCount: totals.undoRepCount + (exercise.repCount || 0),
        }),
        { undoSetCount: 0, undoRepCount: 0 },
      );

      return update(state, {
        calendarItems: {
          [date]: {
            exercises: { $set: exercises },
            setCount: { $set: undoSetCount },
            repCount: { $set: undoRepCount },
          },
        },
        undoDeleteMetadata: { $unset: [metadataKey] },
      });
    }
    case UPDATE_PROGRAMMED_CALENDAR_ITEM_REJECTED: {
      return {
        ...state,
        fetchCalendarItemsError: action.payload,
      };
    }
    case REMOVE_PRESAVE_ITEM_FROM_REDUX: {
      const { date, assignedId } = action.payload;

      const exercises = state.calendarItems[date]?.exercises || [];

      /** Clean local state for that item */
      const { [assignedId]: removed, ...remainingLocalState } = state.preSaveTableLocalState;

      const updatedExercises = exercises.filter(
        (exercise) => exercise.assignedId !== assignedId,
      );

      /** remove deleted item from selected items */
      const updatedSelectedItems = { ...state.selectedItems };
      delete updatedSelectedItems[assignedId];

      return update(state, {
        calendarItems: {
          [date]: {
            exercises: { $set: updatedExercises },
          },
        },
        selectedItems: { $set: updatedSelectedItems },
        preSaveTableLocalState: {
          $set: remainingLocalState,
        },
      });
    }
    case REMOVE_PRESAVE_PROGRAM_ITEM_FROM_REDUX: {
      const { dayNumber, assignedId } = action.payload;

      const exercises = state.nonDateBasedProgramItems?.[dayNumber]?.exercises || [];

      /** Clean local local-state backup */
      const { [assignedId]: removed, ...remainingLocalState } = state.preSaveTableLocalState;

      /** Remove exercise by assignedId */
      const updatedExercises = exercises.filter(
        (exercise) => exercise.assignedId !== assignedId,
      );

      /** remove deleted item from selected items */
      const updatedSelectedItems = { ...state.selectedItems };
      delete updatedSelectedItems[assignedId];

      return update(state, {
        nonDateBasedProgramItems: {
          [dayNumber]: {
            exercises: { $set: updatedExercises },
          },
        },
        selectedItems: { $set: updatedSelectedItems },
        preSaveTableLocalState: {
          $set: remainingLocalState,
        },
      });
    }
    case SET_DELETE_STACK: {
      return {
        ...state,
        deleteStack: action.payload,
      };
    }
    case SET_IS_DRAGGING: {
      return {
        ...state,
        isDragging: action.payload,
      };
    }
    case SET_DRAG_SOURCE: {
      return {
        ...state,
        dragSource: action.payload,
      };
    }

    case SET_PLACEHOLDER_INFO: {
      return {
        ...state,
        placeholderInfo: action.payload,
      };
    }
    case SET_DRAG_IS_IN_PROGRESS: {
      return {
        ...state,
        dragIsInProgress: action.payload,
      };
    }
    case SET_DROPPABLE_CONTAINER_CURRENTLY_HOVERED_BY_DRAGGED_ITEM: {
      return {
        ...state,
        droppableContainerCurrentlyHoveredByDraggedItem: action.payload,
      };
    }
    case SET_DRAGGED_ITEM: {
      return {
        ...state,
        draggedItem: action.payload,
      };
    }
    case SET_REDUX_CALENDAR_CONTAINERS: {
      return {
        ...state,
        calendarItemContainers: {
          programmedCalendarItems: action.payload.programmedCalendarItems,
          liftCalendarItems: action.payload.liftCalendarItems,
          warmUpCalendarItems: action.payload.warmUpCalendarItems,
          SAQCCalendarItems: action.payload.SAQCCalendarItems,
          circuitCalendarItems: action.payload.circuitCalendarItems,
          noteCalendarItems: action.payload.noteCalendarItems,
          questionnaireCalendarItems: action.payload.questionnaireCalendarItems,
          coolDownCalendarItems: action.payload.coolDownCalendarItems,
          healthCalendarItems: action.payload.healthCalendarItems,
          progressionCalendarItems: action.payload.progressionCalendarItems,
          tagCalendarItems: action.payload.tagCalendarItems,
          accessoryCalendarItems: action.payload.accessoryCalendarItems,
        },
      };
    }
    case SET_PROGRAMMED_CALENDAR_ITEMS: {
      return {
        ...state,
        programmedCalendarItems: action.payload,
      };
    }
    case LOG_REDUX_PRESAVE_ADD_INFO: {
      const { id, content } = action.payload;

      return {
        ...state,
        preSaveAddInfo: [
          /** Remove any existing item with the same id */
          ...state.preSaveAddInfo.filter((info) => info.id !== id),
          /** Add the new or updated info */
          { id, content },
        ],
      };
    }
    case LOG_REDUX_PRESAVE_DESCRIPTION: {
      const { id, content } = action.payload;

      return {
        ...state,
        preSaveDescription: [
          /** Remove any existing item with the same id */
          ...state.preSaveDescription.filter((desc) => desc.id !== id),
          /** Add the new or updated description */
          { id, content },
        ],
      };
    }
    case FETCH_RECURRING_CALENDAR_ITEMS_FULFILLED: {
      const requestedRange = action?.payload?.requestedRange;
      const mergedBefore = {
        ...state.beforeRecurringWorkouts,
        ...action.payload.data.beforeWorkoutsObject,
      };
      const mergedAfter = {
        ...state.afterRecurringWorkouts,
        ...action.payload.data.afterWorkoutsObject,
      };

      // Extend the range to include both old and new
      let newEarliest = state.recurringItemsDateRange.earliest;
      let newLatest = state.recurringItemsDateRange.latest;

      if (requestedRange) {
        if (!newEarliest || moment(requestedRange.start).isBefore(newEarliest)) {
          newEarliest = requestedRange.start;
        }
        if (!newLatest || moment(requestedRange.end).isAfter(newLatest)) {
          newLatest = requestedRange.end;
        }
      }

      return {
        ...state,
        beforeRecurringWorkouts: mergedBefore,
        afterRecurringWorkouts: mergedAfter,
        recurringItemsDateRange: {
          earliest: newEarliest,
          latest: newLatest,
        },
        shouldUpdateRecurring: false,
      };
    }
    case CONVERT_RECURRING_ITEM_FULFILLED: {
      /** we have to slice the item out of the calendar array
       * becuase we are converting it
       */
      const { date } = action.payload;

      return update(state, {
        calendarItems: {
          [date]: {
            exercises: {
              $splice: [[action.payload.index, 1]],
            },
          },
        },
      });
    }
    case UPDATE_RECURRING_ITEM_SCHEDULE_FULFILLED: {
      return state;
    }
    case MOVE_EXERCISE_BETWEEN_DATES_START:
      return {
        ...state,
        // Add loading state if needed
      };
    case MOVE_EXERCISE_BETWEEN_DATES_FULFILLED: {
      const {
        data, destinationDate,
      } = action.payload;
      // Update the exercise with new data returned from backend
      const destinationDateFormatted = moment(destinationDate).format('YYYY-MM-DD');

      // Find and update the moved exercise in the destination date
      const destinationExercises = state.calendarItems[destinationDateFormatted]?.exercises || [];
      const updatedDestinationExercises = destinationExercises.map((exercise) => {
        if (exercise.assignedId === data.assignedId) {
          return { ...exercise, ...data };
        }
        return exercise;
      });

      return update(state, {
        calendarItems: {
          [destinationDateFormatted]: {
            exercises: {
              $set: updatedDestinationExercises,
            },
          },
        },
      });
    }
    case MOVE_EXERCISE_BETWEEN_DATES_REJECTED: {
      // Error handling is done through toast in the action
      // Return state unchanged since optimistic update was reverted
      return state;
    }
    case MULTI_MOVE_EXERCISE_BETWEEN_DATES_FULFILLED: {
      const { data, destinationDate } = action.payload;

      const destinationDateFormatted = moment(destinationDate).format('YYYY-MM-DD');

      const destinationExercises = state.calendarItems[destinationDateFormatted]?.exercises || [];

      const updatedDestinationExercises = destinationExercises.map((exercise) => {
        const match = data.find((d) => d.assignedId === exercise.assignedId);
        return match ? { ...exercise, ...match } : exercise;
      });

      return update(state, {
        calendarItems: {
          [destinationDateFormatted]: {
            exercises: {
              $set: updatedDestinationExercises,
            },
          },
        },
      });
    }
    case MOVE_NON_DATE_BASED_EXERCISE_BETWEEN_DAYS_FULFILLED: {
      const { data, destinationDayNumber } = action.payload;

      const destinationExercises = state.nonDateBasedProgramItems[destinationDayNumber]?.exercises || [];

      const updatedDestinationExercises = destinationExercises.map((exercise) => {
        const updatedExercise = data.find(
          (item) => item.assignedId === exercise.assignedId,
        );

        if (updatedExercise) {
          return { ...exercise, ...updatedExercise };
        }

        return exercise;
      });

      return update(state, {
        nonDateBasedProgramItems: {
          [destinationDayNumber]: {
            exercises: {
              $set: updatedDestinationExercises,
            },
          },
        },
      });
    }
    case FETCH_SAVED_WORKOUTS_FULFILLED:
      return {
        ...state,
        savedWorkouts: action.payload.data,
      };
    case FETCH_SAVED_WORKOUT_DETAIL_START:
      return {
        ...state,
        isLoadingSavedWorkout: true,
        savedWorkoutError: null,
      };
    case FETCH_SAVED_WORKOUT_DETAIL_FULFILLED:
      return {
        ...state,
        selectedSavedWorkout: action.payload.data,
        isLoadingSavedWorkout: false,
        savedWorkoutError: null,
      };
    case FETCH_SAVED_WORKOUT_DETAIL_REJECTED:
      return {
        ...state,
        isLoadingSavedWorkout: false,
        savedWorkoutError: action.payload.error,
      };
    case FETCH_SAVED_WORKOUT_FULFILLED: {
      const fetchedItems = action.payload.data; /** object: { [dayNumber]: item } */
      const programChanged = state.nonDateBasedProgramItemsProgramId !== action.payload.savedWorkoutId;
      const { refresh } = action.payload;
      const { weekNumber } = action.payload;

      let mergedItems = {};

      if (programChanged || refresh) {
        /** Program changed → discard local items, only use fetched */
        mergedItems = { ...fetchedItems };
      } else {
        /** Program same → preserve local items that don't conflict */
        const localItems = state.nonDateBasedProgramItems || {};

        /** Start with fetched items (fetched overrides conflicts) */
        mergedItems = { ...fetchedItems };

        /** Add non-conflicting local items */
        Object.entries(localItems).forEach(([key, value]) => {
          const isLocal = value.isLocalItem;
          const conflict = fetchedItems[key]; // key = dayNumber
          if (isLocal && !conflict) {
            mergedItems[key] = value;
          }
        });
      }

      let newSelectedDayNumber = null;

      if (refresh) {
        const items = Object.values(mergedItems);

        /** Does the passed weekNumber still exist? */
        const weekExists = items.some((item) => item.weekNumber === weekNumber);

        let targetWeek;

        if (weekExists) {
          targetWeek = weekNumber;
        } else {
          /** Find all weeks less than the deleted weekNumber */
          const previousWeeks = [];
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < items.length; i++) {
            if (items[i].weekNumber < weekNumber) {
              previousWeeks.push(items[i].weekNumber);
            }
          }

          if (previousWeeks.length === 0) {
            /** No previous weeks exist → return 0 */
            newSelectedDayNumber = 0;
          } else {
            /** Find the largest previous week */
            // eslint-disable-next-line prefer-destructuring
            targetWeek = previousWeeks[0];
            // eslint-disable-next-line no-plusplus
            for (let i = 1; i < previousWeeks.length; i++) {
              if (previousWeeks[i] > targetWeek) {
                targetWeek = previousWeeks[i];
              }
            }
          }
        }

        /** Only attempt lookup if we haven't already set result to 0 */
        if (newSelectedDayNumber !== 0) {
          let targetItem = null;
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < items.length; i++) {
            if (items[i].weekNumber === targetWeek && items[i].dayInWeek === 1) {
              targetItem = items[i];
              break;
            }
          }

          newSelectedDayNumber = targetItem ? targetItem.dayNumber : 0;
        }
      }

      const defaultObject = {
        0: {
          repCount: 0,
          setCount: 0,
          dayInWeek: 1,
          dayNumber: 0,
          weekNumber: 1,
          exercises: [],
          isLocalItem: true,
        },
      };

      return {
        ...state,
        nonDateBasedProgramItems: Object.values(mergedItems)?.length ? mergedItems : defaultObject,
        nonDateBasedProgramItemsProgramId: action.payload.savedWorkoutId,
        /** refresh happens when a user clear a week
         * we want to set the dayNumber to the last day Number before the
         * deleted week
         */
        selectedProgramDayNumber: refresh ? newSelectedDayNumber : state.selectedProgramDayNumber,
      };
    }
    case SET_LAST_UPDATE_TIME: {
      return {
        ...state,
        lastUpdateTime: moment(),
      };
    }
    case UPDATE_WORKOUT_INFO_NAME_FULFILLED: {
      const { formattedDate } = action.payload;

      // If calendar item exists for this date, update it
      if (state.calendarItems[formattedDate]) {
        return update(state, {
          calendarItems: {
            [formattedDate]: {
              title: {
                $set: action.payload.data.title,
              },
            },
          },
        });
      }

      // If no calendar item exists, create a new one with just the title and color
      const newCalendarItems = { ...state.calendarItems };
      newCalendarItems[formattedDate] = {
        date: formattedDate,
        title: action.payload.data.title,
        color: action.payload.data.color,
        exercises: [],
      };

      return {
        ...state,
        calendarItems: newCalendarItems,
      };
    }
    case UPDATE_NON_DATE_BASED_WORKOUT_INFO_NAME_FULFILLED: {
      const { dayNumber } = action.payload;

      // If calendar item exists for this date, update it
      if (state.nonDateBasedProgramItems[dayNumber]) {
        return update(state, {
          nonDateBasedProgramItems: {
            [dayNumber]: {
              title: {
                $set: action.payload.data.title,
              },
              color: {
                $set: action.payload.data.color,
              },
              _updatedAt: { $set: Date.now() },
            },
          },
        });
      }

      // If no calendar item exists, create a new one with just the title and color
      const newProgramItems = { ...state.nonDateBasedProgramItems };
      newProgramItems[dayNumber] = {
        dayNumber,
        title: action.payload.data.title,
        color: action.payload.data.color,
        exercises: [],
      };

      return {
        ...state,
        nonDateBasedProgramItems: newProgramItems,
      };
    }
    case UPDATE_WORKOUT_INFO_COLOR_FULFILLED: {
      const { formattedDate } = action.payload;

      // If calendar item exists for this date, update it
      if (state.calendarItems[formattedDate]) {
        return update(state, {
          calendarItems: {
            [formattedDate]: {
              color: {
                $set: action.payload.data.color,
              },
            },
          },
        });
      }

      // If no calendar item exists, create a new one with just the color and title
      const newCalendarItems = { ...state.calendarItems };
      newCalendarItems[formattedDate] = {
        date: formattedDate,
        title: action.payload.data.title || '',
        color: action.payload.data.color,
        exercises: [],
      };

      return {
        ...state,
        calendarItems: newCalendarItems,
      };
    }
    case SAVE_WORKOUT_TEMPLATE_FULFILLED: {
      return {
        ...state,
        savedWorkouts: [...state.savedWorkouts, action.payload],
      };
    }
    case SHARE_WORKOUT_INFO_START: {
      return {
        ...state,
        sharedWorkoutInfo: null,
      };
    }
    case SHARE_WORKOUT_INFO_FULFILLED: {
      return {
        ...state,
        sharedWorkoutInfo: action.payload.data,
      };
    }
    case SHARE_WORKOUT_INFO_REJECTED: {
      return {
        ...state,
        sharedWorkoutInfo: null,
      };
    }
    case REVERT_LAST_KNOWN_CORRECT_ORDER: {
      return update(state, {
        calendarItems: {
          [action.payload.date]: {
            exercises: {
              $set: action.payload.originalItems,
            },
          },
        },
      });
    }
    case REVERT_LAST_KNOWN_CORRECT_ORDER_FOR_SAVED_WORKOUT: {
      return update(state, {
        nonDateBasedProgramItems: {
          [action.payload.dayNumber]: {
            exercises: {
              $set: action.payload.originalItems,
            },
          },
        },
      });
    }
    case FETCH_CALENDAR_PICKER_ITEMS_START: {
      return {
        ...state,
        calendarPickerItems: {},
      };
    }
    case FETCH_CALENDAR_PICKER_ITEMS_FULFILLED: {
      return {
        ...state,
        calendarPickerItems: action.payload.data,
      };
    }
    case FETCH_CALENDAR_PICKER_ITEMS_REJECTED: {
      return {
        ...state,
        calendarPickerItems: {},
      };
    }
    case FETCH_AND_SET_DEFAULT_CALENDAR_FULFILLED:
      return {
        ...state,
        selectedReduxCalendar: action.payload,
      };
    case FETCH_AND_SET_URL_ATHLETE_FULFILLED:
      return {
        ...state,
        selectedReduxAthlete: action.payload,
      };
    case CREATE_PARENT_CALENDAR_START:
      return {
        ...state,
        calendarCreationError: null,
      };
    case CREATE_PARENT_CALENDAR_FULFILLED:
      return {
        ...state,
        selectedReduxCalendar: action.payload,
        activeModal: '',
        calendarCreationError: null,
        calendarItems: {},
        newlyCreatedCalendar: action.payload,
      };
    case CREATE_PARENT_CALENDAR_REJECTED:
      return {
        ...state,
        calendarCreationError: action.payload,
      };
    case CREATE_A_SAVED_WORKOUT_START:
      return {
        ...state,
        calendarCreationError: null,
      };
    case CREATE_A_SAVED_WORKOUT_FULFILLED:
      return {
        ...state,
        selectedReduxNonDateBasedProgram: action.payload,
        activeModal: '',
        calendarCreationError: null,
        nonDateBasedProgramItems: {},
        newlyCreatedCalendar: action.payload,
      };
    case CREATE_A_SAVED_WORKOUT_REJECTED:
      return {
        ...state,
        calendarCreationError: action.payload,
      };
    case CREATE_PARENT_CHILD_CALENDAR_FULFILLED: {
      const { parentId, parentName, ...calendarData } = action.payload;

      // Create enhanced calendar object with parent info
      const enhancedCalendar = {
        ...calendarData,
        parentCalendarInfo: {
          id: parentId,
          name: parentName,
        },
      };

      return {
        ...state,
        selectedReduxCalendar: enhancedCalendar,
        activeModal: '',
        calendarCreationError: null,
      };
    }
    case CREATE_PARENT_CHILD_CALENDAR_REJECTED:
      return {
        ...state,
        calendarCreationError: action.payload,
      };
    case FETCH_WORKOUT_TEMPLATE_DATA_START: {
      return {
        ...state,
        isLoadingWorkoutTemplateData: true,
        workoutTemplateDataError: null,
      };
    }
    case FETCH_WORKOUT_TEMPLATE_DATA_FULFILLED: {
      return {
        ...state,
        workoutTemplateData: action.payload.data,
        isLoadingWorkoutTemplateData: false,
        workoutTemplateDataError: null,
      };
    }
    case FETCH_WORKOUT_TEMPLATE_DATA_REJECTED: {
      return {
        ...state,
        isLoadingWorkoutTemplateData: false,
        workoutTemplateDataError: action.payload,
      };
    }
    case SET_PRESAVE_TABLE_LOCAL_STATE: {
      const { assignedId, stateObject } = action.payload;
      return {
        ...state,
        preSaveTableLocalState: {
          ...state.preSaveTableLocalState,
          [assignedId]: stateObject,
        },
      };
    }
    case REMOVE_PRESAVE_TABLE_LOCAL_STATE: {
      const { assignedId } = action.payload;
      const { [assignedId]: removed, ...remainingState } = state.preSaveTableLocalState;
      return {
        ...state,
        preSaveTableLocalState: remainingState,
      };
    }
    case CLEAR_PRESAVE_TABLE_LOCAL_STATE: {
      return {
        ...state,
        preSaveTableLocalState: {},
      };
    }
    case SET_VIEW_TYPE: {
      return {
        ...state,
        viewType: action.payload,
      };
    }
    case FETCH_FUTURE_OCCURRENCES_COUNT_START: {
      return {
        ...state,
        futureOccurrencesCount: null,
      };
    }
    case FETCH_FUTURE_OCCURRENCES_COUNT_FULFILLED: {
      return {
        ...state,
        futureOccurrencesCount: action.payload.count,
      };
    }
    case FETCH_FUTURE_OCCURRENCES_COUNT_REJECTED: {
      return {
        ...state,
        futureOccurrencesCount: null,
      };
    }
    default: {
      // Handle namespaced actions for week view support
      const actionType = action.type;

      // Check if this is a namespaced action by looking for the namespace pattern
      if (actionType.includes('/')) {
        // eslint-disable-next-line no-unused-vars
        const [namespace, baseActionType] = actionType.split('/');

        switch (baseActionType) {
          case SET_CALENDAR_ITEMS_NAMESPACED: {
            // Ensure the date object exists before updating
            const dateExists = state.calendarItems[action.payload.date];
            if (!dateExists) {
              return update(state, {
                calendarItems: {
                  [action.payload.date]: {
                    $set: {
                      exercises: action.payload.calendarItemsArray,
                    },
                  },
                },
              });
            }
            return update(state, {
              calendarItems: {
                [action.payload.date]: {
                  exercises: {
                    $set: action.payload.calendarItemsArray,
                  },
                },
              },
            });
          }
          case UPDATE_CALENDAR_ITEMS_ORDER_START_NAMESPACED: {
            // Can add loading states per namespace if needed
            return state;
          }
          case UPDATE_CALENDAR_ITEMS_ORDER_FULFILLED_NAMESPACED: {
            // Handle successful reorder for namespaced actions
            return state;
          }
          case UPDATE_CALENDAR_ITEMS_ORDER_REJECTED_NAMESPACED: {
            // Handle error states per namespace if needed
            return state;
          }
          case ADD_PRESAVED_ITEM_TO_CALENDAR_ITEMS_ARRAY_NAMESPACED: {
            const { copiedItem, endpointFormattedDate, destinationIndex } = action.payload;
            const currentExercises = state.calendarItems[endpointFormattedDate]?.exercises || [];
            const newExercises = [...currentExercises];
            newExercises.splice(destinationIndex, 0, copiedItem);

            return update(state, {
              calendarItems: {
                [endpointFormattedDate]: {
                  exercises: {
                    $set: newExercises,
                  },
                },
              },
            });
          }
          case SET_COMBINE_WITH_INFO_NAMESPACED: {
            return {
              ...state,
              combineWithInfo: action.payload.combineInfo,
            };
          }
          default:
            return state;
        }
      }

      return {
        ...state,
      };
    }
  }
}
